import { useState, useEffect } from 'react';

export const useTheme = () => {
    const [theme, setTheme] = useState(() => {
        const savedTheme = localStorage.getItem("theme");
        return savedTheme !== null ? savedTheme : "dark";
  });

  const toggleTheme = () => {
      setTheme(prevTheme => (prevTheme === "light" ? "dark" : "light"));
  };

  useEffect(() => {
      document.body.className = theme === "dark" ? "dark-mode" : "";
      localStorage.setItem("theme", theme);
  }, [theme]);

  return { theme, toggleTheme };
};
